module.exports = __webpack_public_path__ + "img/tips-gear.6e004fdf.svg";